export default __webpack_public_path__ + "static/media/mlab2.2481f3cf.JPG";